import { render } from "./LayerOpacityControl.vue?vue&type=template&id=058097f0"
import script from "./LayerOpacityControl.vue?vue&type=script&lang=js"
export * from "./LayerOpacityControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__